export type AttachTaskCreator = {
  id: string;
  name: string;
  image?: string;
  deliverableIds: string[];
};

export type AttachTaskDeliverableOption = {
  taskId: string;
  name: string;
  deliverableConfigRefId: string;
};

export function listMatchingDeliverableTasks(
  config:
    | Array<{
        name: string;
        deliverableConfigRefId: string;
        tasks?: Array<{ type: string; taskId: string }>;
      }>
    | undefined,
  type: string
): AttachTaskDeliverableOption[] {
  return (config || []).flatMap((deliverable) =>
    (deliverable.tasks || [])
      .filter((task) => task.type === type)
      .map((task) => ({
        taskId: task.taskId,
        name: deliverable.name,
        deliverableConfigRefId: deliverable.deliverableConfigRefId,
      }))
  );
}

export function countMatchingCreators(
  creators: AttachTaskCreator[],
  deliverableConfigRefId: string
) {
  return creators.filter((creator) =>
    creator.deliverableIds.includes(deliverableConfigRefId)
  ).length;
}

export function hasBriefHtml(html: string) {
  if (!html.trim()) return false;
  if (/<(img|video|audio|iframe)\b/i.test(html)) return true;
  if (/data-content-type=["'](?:image|video|audio|file)["']/i.test(html)) {
    return true;
  }
  return html.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim().length > 0;
}

export function editorHasAttachableContent(
  editor: { hasContent: () => boolean; getHTML: (options?: { syncTokens?: boolean }) => string } | null
) {
  if (!editor) return false;
  try {
    return (
      editor.hasContent() || hasBriefHtml(editor.getHTML({ syncTokens: false }))
    );
  } catch {
    return false;
  }
}
